import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export interface ConfirmDialogProps {
    title: string,
    text: string,
    open: boolean,
    onConfirm: () => void,
    onCancel: () => void
}

export default function ConfirmDialog(props: ConfirmDialogProps) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onCancel}
            onClick={event => {event.stopPropagation();}}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
        >
            <DialogTitle id="confirm-dialog-title">
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirm-dialog-description">
                    {props.text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onCancel} autoFocus>Cancel</Button>
                <Button variant="contained" onClick={props.onConfirm}>Confirm</Button>
            </DialogActions>
        </Dialog>
    );
}